((w, d) => {
	let y = w.pageYOffset;
	const header = d.getElementsByClassName("header")[0];
	const css = "header--active";
	function addClass() {
		y = w.pageYOffset;
		y > 0 ? header.classList.add(css) : header.classList.remove(css);
	}
	w.addEventListener("load", addClass);
	w.addEventListener("scroll", addClass);
})(window, document);
